import { render, staticRenderFns } from "./AuthorInfo.vue?vue&type=template&id=509c49b9"
import script from "./AuthorInfo.vue?vue&type=script&lang=js"
export * from "./AuthorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports